import generateUtilityClass from "@suid/base/generateUtilityClass";
import generateUtilityClasses from "@suid/base/generateUtilityClasses";
export function getPopoverUtilityClass(slot) {
    return generateUtilityClass("MuiPopover", slot);
}
const popoverClasses = generateUtilityClasses("MuiPopover", [
    "root",
    "paper",
]);
export default popoverClasses;
